export const sexOptions = [
    {value: 'man', label: 'Man'},
    {value: 'woman', label: 'Woman'}
]
